import styled from "@emotion/styled";
import { Container, Link } from "@mui/material";

const MenuContainer = styled.div`
  width: 100%;
  z-index: 9999;
  transition: all linear 0.3s;
  position: ${(props) => (props.isSticky == "sticky" ? "fixed" : "absolute")};
  background-color: ${(props) => (props.isSticky == "sticky" ? "black" : "")};
  padding: ${(props) => (props.isSticky == "sticky" ? "" : "15px 0")};
  box-shadow: ${(props) =>
    props.isSticky == "sticky" ? "0px 3px 7px rgba(0, 0, 0, 0.51)" : ""};
  img {
    width: ${(props) => (props.isSticky == "80px !important" ? "" : "")};
  }
`;
const DesktopMainMenu = styled(Container)`
  padding: 12px 3rem !important;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 899px) {
    display: none;
  }
`;
const MobileMainMenu = styled.div`
  /* background-color: #fff; */
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 20px;

  @media (min-width: 900px) {
    display: none;
  }
`;
const SiteLogo = styled.img`
  max-width: 100%;
  height: auto;
`;
const MenuLink = styled(Link)`
  align-items: center !important;
  font-size: max(15px, 17px);
  font-family: "Lucida-Regular";
  font-weight: bolder;
  color: rgba(255, 255, 255, 1);
  /* color: #000; */
  text-transform: uppercase;
  text-decoration: none;
  cursor: pointer;
  transition-duration: 0.5s;
  &:nth-child(3) {
    cursor: pointer;
    background: linear-gradient(to right, #ff3ffd, #fed900);
    text-shadow: 2px 1px 12.9px #ec9dc1;
    background-size: cover;
    background-clip: text;
    -webkit-background-clip: text;
    color: transparent;
    border-radius: 24px;
    padding: 10px 20px 10px 20px;
    font-family: "Lucida-Regular";
    font-size: 20px;
    /* opacity: 1; */
    /* box-shadow: ${(props) =>
      props.bs ? props.bs : "inset 0px 2px 5px 0px white"}; */
    &:hover {
      /* color: #000; */
      /* opacity: 1; */
    }
  }
  &:hover,
  &:active,
  &:focus {
    opacity: 0.8;
    /* color: #fff; */
    transition-duration: 0.5s;
  }
  @media (max-width: 899px) {
    display: block;
    color: #fff;
    padding: 15px 0 15px 2%;
    border-bottom: 1px solid #1a1a1a;
    text-align: left;

    &:nth-child(3) {
      padding-top: 25px;
    }
  }
  &:nth-child(6) {
    padding: 0px;
    border-width: 0px;
  }
`;

export { MenuContainer, DesktopMainMenu, MobileMainMenu, MenuLink, SiteLogo };
